import { render } from "./SystemRequestView.vue?vue&type=template&id=9e534ef4"
import script from "./SystemRequestView.vue?vue&type=script&lang=js"
export * from "./SystemRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__